export default class StorageKeys {
  static lang = 'lang';
  static authSid = 'authSid';
}
